module.exports = __webpack_public_path__ + "img/man_dog.9e55e8d0.png";